import { NavigationBar } from "./common/NavigationBar";
import { useFunnel } from "../context/FunnelContext";
import { ProgressBar } from "./common/ProgressBar";
import { stepsConfig } from "../config/steps";

export function MainLayout({ children }) {
  const { state } = useFunnel();
  const currentStepConfig = stepsConfig.steps[state.currentStep];

  // For splash screens, get the associated step config
  const isSplashScreen =
    typeof state.currentStep === "string" &&
    state.currentStep.startsWith("splash_");

  const isWelcomeStep = state.currentStep === 0;

  const stepConfig = isSplashScreen
    ? stepsConfig.steps[parseInt(state.currentStep.split("_")[1])]
    : currentStepConfig;

  // Default to true if not explicitly set to false
  const showProgress = stepConfig?.showProgress !== false;
  const hideNavigation =
    stepConfig?.hideNavigation === true || isSplashScreen || isWelcomeStep;

  return (
    <div className="flex flex-col min-h-screen-dynamic bg-gray-100 overflow-x-hidden">
      {!hideNavigation && (
        <header className="sticky top-0 z-10 w-full bg-gray-100">
          <div className="max-w-[420px] mx-auto">
            <NavigationBar />
            {showProgress && <ProgressBar currentStep={state.currentStep} />}
          </div>
        </header>
      )}
      <main className="flex-1 w-full max-w-[420px] mx-auto overflow-x-hidden">
        {children}
      </main>
    </div>
  );
}
